import { IconProps } from '../../utils/icon';
import { Svg } from '../../utils/IconBase';

const IconPaymentsLine = ({ width, height, fill = 'currentColor', ...props }: IconProps) => {
  return (
    <Svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M13.75 12.711c-.699 0-1.29-.242-1.774-.726a2.413 2.413 0 0 1-.726-1.774c0-.698.242-1.29.726-1.774a2.413 2.413 0 0 1 1.774-.726c.699 0 1.29.242 1.774.726s.726 1.076.726 1.774c0 .7-.242 1.29-.726 1.774a2.413 2.413 0 0 1-1.774.726Zm-6.596 3.097a1.74 1.74 0 0 1-1.277-.531A1.74 1.74 0 0 1 5.347 14V6.423c0-.497.176-.923.53-1.277a1.74 1.74 0 0 1 1.277-.53h13.192c.497 0 .923.176 1.277.53.354.354.53.78.53 1.277V14c0 .497-.176.923-.53 1.277a1.74 1.74 0 0 1-1.277.53H7.154Zm1.5-1.5h10.192c0-.499.177-.925.531-1.278.354-.353.78-.53 1.277-.53V7.923a1.74 1.74 0 0 1-1.278-.531 1.743 1.743 0 0 1-.53-1.277H8.654c0 .5-.177.925-.531 1.278-.354.353-.78.53-1.277.53V12.5c.499 0 .925.177 1.278.531.353.354.53.78.53 1.277Zm9.769 5H3.653a1.74 1.74 0 0 1-1.276-.531 1.74 1.74 0 0 1-.53-1.277V8.346c0-.212.071-.39.215-.534a.726.726 0 0 1 .534-.216c.213 0 .391.072.535.216a.726.726 0 0 1 .215.534V17.5c0 .077.032.147.096.212a.295.295 0 0 0 .212.096h14.769c.212 0 .39.072.534.215a.726.726 0 0 1 .216.535c0 .213-.072.39-.216.534a.726.726 0 0 1-.534.216Zm-11.27-5h-.307V6.115h.308a.296.296 0 0 0-.217.092.296.296 0 0 0-.09.216V14c0 .083.03.155.09.216a.296.296 0 0 0 .217.092Z"
        fill={fill}
      />
    </Svg>
  );
};

export default IconPaymentsLine;
